import React, { Component } from 'react';

import * as util from '#packages/util';
import * as stateManagement from '#packages/stateManagement';

import connectWithEditor from '../../util/connectWithEditor';

import type { MapDispatchToProps } from 'types/redux';

const { setTopBarHeight } = stateManagement.config.actions;
const { isPropChanged } = util;

interface WithSetHeightBehaviorOwnProps {
  isPreviewMode: boolean;
  isMinimized: boolean;
  isSectionsMigrationBannerEnabled: boolean;
}

interface WithSetHeightBehaviorDispatchProps {
  setTopBarHeight: (val: number) => void;
}

interface WithSetHeightBehaviorProps
  extends WithSetHeightBehaviorOwnProps,
    WithSetHeightBehaviorDispatchProps {}

const mapDispatchToProps: MapDispatchToProps<
  WithSetHeightBehaviorDispatchProps,
  WithSetHeightBehaviorOwnProps
> = {
  setTopBarHeight,
};

const withSetHeightBehavior = (WrappedComponent: AnyFixMe) => {
  class WithSetHeightBehavior extends Component<WithSetHeightBehaviorProps> {
    componentDidMount() {
      this.setTwoDecksTopBarHeight();
    }

    componentDidUpdate(prevProps: Readonly<WithSetHeightBehaviorProps>) {
      if (
        isPropChanged(prevProps, this.props, [
          'isPreviewMode',
          'isMinimized',
          'isSectionsMigrationBannerEnabled', // isSectionsMigrationBannerEnabled could changed after migration finished
        ])
      ) {
        if (this.props.isPreviewMode || this.props.isMinimized) {
          this.setOneDeckTopBarHeight();
        } else {
          this.setTwoDecksTopBarHeight();
        }
      }
    }

    setTwoDecksTopBarHeight = () => {
      this.props.setTopBarHeight(util.topBar.getHeightConst());
    };

    setOneDeckTopBarHeight = () => {
      this.props.setTopBarHeight(util.topBar.getUpperDeckHeightConst());
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return connectWithEditor(null, mapDispatchToProps)(WithSetHeightBehavior);
};

export default withSetHeightBehavior;
